export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * Returns a regex that matches a decimal number string with up to `maxDecimalPlaces` digits after the dot.
 * E.g. isValidDecimalString(2) matches "1", "1.", "1.5", "1.25" but not "1.123"
 */
export const isValidDecimalString = (maxDecimalPlaces: number = 2): RegExp =>
  new RegExp(`^\\d*\\.?\\d{0,${maxDecimalPlaces}}$`);
